import { Col, Container, Row } from "react-bootstrap";
import "./Buttons.css";
import SimulationApi from "../../API/SimulationApi";
import useStore from "../../Zustand/Zustand";
import ZustandFormImovel from "../../Zustand/ZustandFormImovel";
import ZustandValidationConjugue from "../../Zustand/ZustandValidationConjugue";
import ZustandValidationProponente from "../../Zustand/ZustandFormProponent";
import convertToFloat from "../../Utils/convertToFloat";
import convertDateFormat from "../../Utils/convertDateFormat";
import ZustandDadosDeFinanciamento from "../../Zustand/ZustandDadosDeFinanciamento";

const Buttons = () => {
  const {
    nomeCompleto,
    emailPrincipal,
    idadeCliente,
    numero,
    rendaMensalClient,
    cpf,
    nascimentoProponente4,
    rendaMensalProponent4,
  } = useStore();

  const {
    setTaxaBrb,
    setTaxaBradesco,
    setTaxaCaixa,
    setTaxaInter,
    setTaxaSantander,
    setTaxaItau,
  } = ZustandDadosDeFinanciamento();

  const {
    situacaoImovel,
    valorDoImovel,
    valorFGTS,
    valorDeEntrada,
    prazoMeses,
  } = ZustandFormImovel();

  const { nomeConjugue, rendaConjugue, nascimentoConjugue } =
    ZustandValidationConjugue();

  const { nomeProponente, rendaProponente, nascimentoProponente } =
    ZustandValidationProponente();

  const convertRendaCongue = convertToFloat(rendaConjugue)
  const convertRendaProponete3 = convertToFloat(rendaProponente)
  const convertRendaProponente4 = convertToFloat(rendaMensalProponent4)

  return (
    <Container className="d-flex justify-content-center mt-5 mb-5">
      <Row>
        <Col>
          <button
            className="clear-button"
            onClick={() => {
              setTaxaBrb(0)
              setTaxaBradesco(0)
              setTaxaCaixa(0)
              setTaxaInter(0)
              setTaxaSantander(0)
              setTaxaItau(0)
            }}
          >
            Limpar
          </button>
        </Col>
        <Col>
          <SimulationApi
            tipoImovel="Residencial"
            estadoImovel=""
            situacaoImovel={situacaoImovel}
            valorImovel={convertToFloat(valorDoImovel)}
            valorFinanciamento={convertToFloat(
              valorDoImovel - valorDeEntrada - valorFGTS
            )}
            valorEntrada={convertToFloat(valorDeEntrada)}
            valorFGTS={convertToFloat(valorFGTS)}
            prazo={prazoMeses}
            nome={nomeCompleto}
            dataNascimento={convertDateFormat(idadeCliente)}
            cpf={cpf}
            renda={rendaMensalClient}
            email={emailPrincipal}
            conjugeNome={nomeConjugue}
            conjugeRenda={String(rendaConjugue)}
            totalRendaCasal={String(convertRendaCongue + rendaMensalClient)}
            conjugeDataNascimento={nascimentoConjugue}
            proponenteNome={nomeProponente}
            proponenteRenda={String(rendaProponente)}
            proponenteDataNascimento={nascimentoProponente}
            proponenteNome2={nomeProponente}
            proponenteRenda2={String(convertRendaProponente4)}
            proponenteDataNascimento2={nascimentoProponente4}
            totalRendaProponentes={String(
              convertRendaProponete3 + convertRendaProponente4
            )}
            totalRendaSimulacao={
              rendaMensalClient +
              convertRendaCongue +
              convertRendaProponete3 +
              convertRendaProponente4
            }
            id=""
            telefone={numero}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Buttons;
